/* pokelix v3 — Wishlist (localStorage) + Zuletzt angesehen + Scroll-Reveal (2026-07-03) */
(function () {
  'use strict';

  var WISH_KEY = 'pokelixWishlist';
  var RECENT_KEY = 'pokelixRecent';

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function write(key, v) {
    try { localStorage.setItem(key, JSON.stringify(v)); } catch (e) { /* private mode */ }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';

  var CARD_SEL = '.card-wrapper.product-card-wrapper';

  /* ---------------- Wishlist core ---------------- */

  function wishHas(url) {
    return read(WISH_KEY).some(function (i) { return i.url === url; });
  }

  function wishToggle(item) {
    if (!item || !item.url) return false;
    var list = read(WISH_KEY);
    var idx = -1;
    for (var i = 0; i < list.length; i++) { if (list[i].url === item.url) { idx = i; break; } }
    if (idx > -1) { list.splice(idx, 1); } else { list.unshift(item); }
    if (list.length > 40) list.length = 40;
    write(WISH_KEY, list);
    updateHeadCount();
    renderDrawer();
    return idx === -1;
  }

  function cardData(wrap) {
    var link = wrap.querySelector('.card__heading a');
    var img = wrap.querySelector('.card__media img');
    var price = wrap.querySelector('.price-item--sale, .price-item--regular');
    if (!link || !link.getAttribute('href')) return null;
    var href = link.getAttribute('href');
    if (href.indexOf('/products/') === -1) return null;
    return {
      url: href.split('?')[0],
      title: (link.textContent || '').trim(),
      image: img ? (img.currentSrc || img.src || '') : '',
      price: price ? (price.textContent || '').trim() : ''
    };
  }

  function injectHearts() {
    document.querySelectorAll(CARD_SEL).forEach(function (wrap) {
      if (wrap.querySelector('.plx-wish')) return;
      var card = wrap.querySelector('.card');
      var data = cardData(wrap);
      if (!card || !data) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'plx-wish' + (wishHas(data.url) ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Zur Merkliste hinzufügen');
      btn.innerHTML = HEART_SVG;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var added = wishToggle(cardData(wrap) || data);
        btn.classList.toggle('is-active', added);
        btn.classList.remove('plx-wish--pop');
        void btn.offsetWidth;
        btn.classList.add('plx-wish--pop');
      });
      wrap.appendChild(btn);
    });
  }

  /* ---------------- Header-Chip + Drawer ---------------- */

  function updateHeadCount() {
    var n = read(WISH_KEY).length;
    document.querySelectorAll('.plx-wish-head__count').forEach(function (c) {
      c.textContent = n;
      c.classList.toggle('is-empty', n === 0);
    });
  }

  function buildHead() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.plx-wish-head')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'plx-wish-head';
    btn.setAttribute('aria-label', 'Merkliste öffnen');
    btn.innerHTML = HEART_SVG + '<span class="plx-wish-head__count is-empty">0</span>';
    btn.addEventListener('click', function () { toggleDrawer(true); });
    var cart = icons.querySelector('a[href*="/cart"]');
    icons.insertBefore(btn, cart || null);
    updateHeadCount();
  }

  var drawer;

  function buildDrawer() {
    if (document.querySelector('.plx-wishdrawer')) { drawer = document.querySelector('.plx-wishdrawer'); return; }
    drawer = document.createElement('div');
    drawer.className = 'plx-wishdrawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="plx-wishdrawer__overlay" data-plx-wish-close></div>' +
      '<div class="plx-wishdrawer__panel" role="dialog" aria-label="Merkliste">' +
      '  <div class="plx-wishdrawer__head">' +
      '    <h2 class="plx-wishdrawer__title">Merkliste</h2>' +
      '    <button type="button" class="plx-wishdrawer__close" data-plx-wish-close aria-label="Schließen">&times;</button>' +
      '  </div>' +
      '  <ul class="plx-wishdrawer__list"></ul>' +
      '</div>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-plx-wish-close]')) { toggleDrawer(false); return; }
      var rm = e.target.closest('[data-plx-wish-remove]');
      if (rm) {
        wishToggle({ url: rm.getAttribute('data-plx-wish-remove') });
        injectSync();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') toggleDrawer(false);
    });
    renderDrawer();
  }

  function renderDrawer() {
    if (!drawer) return;
    var list = drawer.querySelector('.plx-wishdrawer__list');
    var items = read(WISH_KEY);
    if (!items.length) {
      list.innerHTML = '<li class="plx-wishdrawer__empty">Noch nichts gemerkt.<br>Tippe das Herz auf einem Produkt, um es hier zu speichern.</li>';
      return;
    }
    list.innerHTML = items.map(function (i) {
      return '<li class="plx-wishdrawer__item">' +
        '<a class="plx-wishdrawer__link" href="' + esc(i.url) + '">' +
        (i.image ? '<img class="plx-wishdrawer__img" src="' + esc(i.image) + '" alt="" loading="lazy">' : '<span class="plx-wishdrawer__img"></span>') +
        '</a>' +
        '<a class="plx-wishdrawer__link" href="' + esc(i.url) + '">' +
        '<p class="plx-wishdrawer__name">' + esc(i.title) + '</p>' +
        '<span class="plx-wishdrawer__price">' + esc(i.price) + '</span>' +
        '</a>' +
        '<button type="button" class="plx-wishdrawer__remove" data-plx-wish-remove="' + esc(i.url) + '" aria-label="Entfernen">&times;</button>' +
        '</li>';
    }).join('');
  }

  function toggleDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) renderDrawer();
  }

  /* Herz-Zustände nach Drawer-Remove syncen */
  function injectSync() {
    document.querySelectorAll(CARD_SEL).forEach(function (wrap) {
      var btn = wrap.querySelector('.plx-wish');
      var data = cardData(wrap);
      if (btn && data) btn.classList.toggle('is-active', wishHas(data.url));
    });
  }

  /* ---------------- Zuletzt angesehen ---------------- */

  function recordProduct() {
    if (!/^\/([a-z]{2}(-[A-Z]{2})?\/)?products\//.test(location.pathname)) return;
    var titleMeta = document.querySelector('meta[property="og:title"]');
    var imgMeta = document.querySelector('meta[property="og:image"], meta[property="og:image:secure_url"]');
    var priceEl = document.querySelector('.product__info-container .price-item--sale, .product__info-container .price-item--regular');
    var item = {
      url: location.pathname.split('?')[0],
      title: titleMeta ? titleMeta.content : document.title.split('–')[0].trim(),
      image: imgMeta ? imgMeta.content : '',
      price: priceEl ? (priceEl.textContent || '').trim() : ''
    };
    if (!item.title) return;
    var list = read(RECENT_KEY).filter(function (i) { return i.url !== item.url; });
    list.unshift(item);
    if (list.length > 8) list.length = 8;
    write(RECENT_KEY, list);
  }

  function renderRecent() {
    var grid = document.getElementById('plx-recent-grid');
    if (!grid) return;
    var here = location.pathname.split('?')[0];
    var items = read(RECENT_KEY).filter(function (i) { return i.url !== here; }).slice(0, 4);
    var section = grid.closest('.plx-recent');
    if (!items.length) {
      if (section) section.style.display = 'none';
      return;
    }
    if (section) section.style.display = '';
    grid.innerHTML = items.map(function (i) {
      return '<a class="plx-recent__card" href="' + esc(i.url) + '">' +
        '<span class="plx-recent__media">' + (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="plx-recent__name">' + esc(i.title) + '</span>' +
        '<span class="plx-recent__price">' + esc(i.price) + '</span>' +
        '</a>';
    }).join('');
  }

  /* ---------------- Scroll-Reveal ---------------- */

  function reveal() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.plx-fade-up').forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Init ---------------- */

  function init() {
    buildHead();
    buildDrawer();
    injectHearts();
    recordProduct();
    renderRecent();
    reveal();
    if ('MutationObserver' in window) {
      new MutationObserver(function () { injectHearts(); }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
